import { render, staticRenderFns } from "./SlideCaptcha.vue?vue&type=template&id=52551394&"
import script from "./SlideCaptcha.vue?vue&type=script&lang=js&"
export * from "./SlideCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./SlideCaptcha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports